(() => {
  const selector = "[data-erkon-shipping-countdown]";
  const shippingFormatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Istanbul",
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit",
    hourCycle: "h23"
  });
  const dispatchDateFormatter = new Intl.DateTimeFormat("tr-TR", {
    timeZone: "UTC", day: "numeric", month: "long", weekday: "long"
  });
  const shippingExceptions = { "2026-10-28": 12, "2026-10-29": null };
  const getShippingSchedule = (now, cutoffHour = 16) => {
    const parts = {};
    shippingFormatter.formatToParts(now).forEach(({ type, value }) => {
      if (type !== "literal") parts[type] = Number(value);
    });
    const nowWallClock = Date.UTC(parts.year, parts.month - 1, parts.day,
      parts.hour, parts.minute, parts.second, now.getUTCMilliseconds());
    let day = Date.UTC(parts.year, parts.month - 1, parts.day);
    let targetWallClock;
    while (targetWallClock === undefined) {
      const date = new Date(day);
      const dateKey = date.toISOString().slice(0, 10);
      const weekday = date.getUTCDay();
      const hour = Object.prototype.hasOwnProperty.call(shippingExceptions, dateKey)
        ? shippingExceptions[dateKey] : cutoffHour;
      const candidate = day + hour * 60 * 60 * 1000;
      if (weekday !== 0 && weekday !== 6 && hour !== null && candidate > nowWallClock) {
        targetWallClock = candidate;
      } else {
        day += 24 * 60 * 60 * 1000;
      }
    }
    const target = new Date(targetWallClock);
    const targetHour = String(target.getUTCHours()).padStart(2, "0") + ".00";
    const holidayNotice = nowWallClock >= Date.UTC(2026, 9, 28)
      && nowWallClock < Date.UTC(2026, 9, 30)
      ? "29 Ekim'de kargo çıkışı yoktur. " : "";
    return {
      remainingSeconds: Math.max(0, Math.ceil((targetWallClock - nowWallClock) / 1000)),
      message: holidayNotice + "Sonraki kargo: "
        + dispatchDateFormatter.format(target) + " " + targetHour + "."
    };
  };

  const initializeCountdowns = (root = document) => {
    const countdowns = [];
    if (root.matches && root.matches(selector)) countdowns.push(root);
    countdowns.push(...root.querySelectorAll(selector));

    countdowns.forEach((container) => {
      if (container.dataset.countdownInitialized === "true") return;
      const output = container.querySelector("[data-erkon-shipping-timer]");
      if (!output) return;

      container.dataset.countdownInitialized = "true";
      const update = () => {
        const schedule = getShippingSchedule(new Date());
        const remainingSeconds = schedule.remainingSeconds;
        const dispatch = container.nextElementSibling?.querySelector(".erkon-shipping-dispatch-info__text");
        if (dispatch && dispatch.textContent !== schedule.message) dispatch.textContent = schedule.message;

        const hours = String(Math.floor(remainingSeconds / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((remainingSeconds % 3600) / 60)).padStart(2, "0");
        const seconds = String(remainingSeconds % 60).padStart(2, "0");
        output.textContent = hours + ":" + minutes + ":" + seconds;
      };

      update();
      window.setInterval(update, 1000);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeCountdowns(), { once: true });
  } else {
    initializeCountdowns();
  }

  document.addEventListener("shopify:section:load", (event) => initializeCountdowns(event.target));
})();
